export const getFileName = (path: string): string | null => {
  return path.split("/").pop() ?? null;
};

export const getFileExtension = (path: string) => {
  return path.split(".").pop();
};
